import React from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const PayPalErrorModal = (props) => {
    const { contactSupport, gotIt, onErrorMessage, onErrorTitle } = usePageMessages();

    return (
        <ModalComponent canCloseModal={false} isVerticalCentered>
            <InfoPage
                insideModalComponent={true}
                animatedIconFail
                headerText={onErrorTitle}
                secondaryText={onErrorMessage}
                buttonRowCaption={contactSupport}
                buttonRowType="link"
                buttonRowOnClick={() => {
                    props.toggleChat(true);
                }}
                primaryButtonType="link"
                primaryButtonCaption={gotIt}
                primaryButtonLink={AUTH_SEND_MAIN_LINK}
            />
        </ModalComponent>
    );
};
export default connect(null, { toggleChat })(PayPalErrorModal);
